<template>
  <div class="">
    <div class="head-title">KPI设置</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、设置企业不同部门或员工的年度、季度、月度的KPI目标。管理员可根据自定义时间查看一定时间内的销售KPI、回款KPI等详细数据，可对企业部门和员工目标进行及时调整。
          </p>
          <p>
            2、员工在CRM的PC端、手机端，均可查看个人的销售KPI及回款KPI数据。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="">
      <div class="mMain">
        <div class="tianjia">
          <div class="tabs">
            <el-form label-width="12.0rem">
              <span
                @click="sensitiven()"
                class="tab"
                :class="sensitive == true ? 'dianji' : 'falsell'"
                >部门</span
              >
              <span
                @click="delen()"
                class="tab"
                :class="dele == true ? 'dianji' : 'falsell'"
                >员工</span
              >
            </el-form>
          </div>
          <div v-if="sensitive == true" class="abc">
            <department></department>
          </div>
          <div class="bac" v-if="dele == true">
            <staff></staff>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Staff from "../../components/api/staff.vue";
import Department from "../../components/api/department.vue";
export default {
  data() {
    return {
      tableData: [],
      hasChildren: true,
      tooken: "",
      sensitive: true, //敏感词触发
      dele: false, //删除事件
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
  },
  methods: {
    //敏感词触发
    sensitiven() {
      this.sensitive = true;
      this.dele = false;
    },
    //删除事件
    delen() {
      this.sensitive = false;
      this.dele = true;
    },
  },
  components: {
    Staff,
    Department,
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.tabs {
  border-bottom: .1rem solid #eee;
}
.tabs .tab {
  display: inline-block;
  line-height: 5.0rem;
  text-align: center;
  cursor: pointer;
  margin: 0 2.0rem;
  padding: 0 1.2rem;
  font-weight: 500;
  font-size: 2.2rem;
}
.dianji {
  border-bottom: .2rem solid;
  color: #49B372;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}

.wei_body {
  margin-top: 1.0rem;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 2.6rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>

